import { gql } from "@apollo/client";

export const SET_VIEWER_SETTING = gql`
  mutation SetViewerSetting($key: String!, $value: String!) {
    changeViewerSetting(key: $key, value: $value)
  }
`;
